<template>
  <section>
    <router-link :to="{ name: 'Coupon', params: { id: 'christmas_discount' } }"
      class="d-flex align-items-center justify-content-between gf_discount-banner">
      <span class="gf_discount-banner__content-left">{{ $t("chrismastBanner.title") }}</span>
      <div class="d-flex align-items-center justify-content-end">
        <div class="gf_discount-banner__content-center d-flex align-items-center mr-4">
          <span class="mr-1">{{ $t("chrismastBanner.lifetime") }}</span>
          <span class="off-15">{{ $t("chrismastBanner.saleOff") }}</span>
          <span>{{ $t("chrismastBanner.businessPlan") }}</span>
        </div>
        <span class="gf_discount-banner__content-right">{{ $t("chrismastBanner.claimButton") }}</span>
      </div>
    </router-link>
  </section>
</template>

<script>
export default {
  name: "ChrismastBanner"
}
</script>

<style lang="scss" scoped>
  .gf_discount-banner {
    height: 88px;
    padding: 0 130px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("~@/core/assets/banner/chrismast_banner.png");
    margin-bottom:32px;

    &__content-left {
      font-weight: bold;
      font-size: 24px;
      line-height: 31px;
      color: #FFFFFF;
    }

    &__content-center {
      span {
        font-size: 24px;
        line-height: 31px;
        color: #FFFFFF;
      }

      .off-15 {
        color: #FFAA00;
        font-weight: bold;
        font-size: 26px;
        margin-right: 9px;
      }
    }

    &__content-right {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;
      width: 189px;
      height: 48px;
      background: #FFBB1C;
      border-radius: 3px;
      font-weight: bold;
      font-size: 20px;
      color: #20273A;
    }

    @media (min-width: 1440px) and (max-width: 1552px) {
      padding: 0 80px;

      &__content-left {
        width: 188px;
      }

      &__.content-right {
        width: 153px;
        height: 40px;
        font-size: 16px;
      }
    }

    @media (max-width: 1440px) {
      padding: 0 60px;
    }

    @media (max-width: 1150px) {
      padding: 0 16px;

      &__content-left {
        width: 188px;
        font-size: 20px;
      }

      &__content-center {
        span {
          font-size: 20px;
        }
      }

      &__content-right {
        width: 153px;
        height: 40px;
        font-size: 16px;
      }
    }
  }
</style>
